'use client';
import { useBrand } from '@curology/ui-components-web/brand/context';
import AgencyLogoStickerInverseIcon from '@curology/ui-components-web/react/Icon/icons/AgencyLogoStickerInverseIcon';
import { CurologyLogoStickerIcon } from '@curology/ui-components-web/react/Icon/icons/CurologyLogoStickerIcon';
import { Typography } from '@curology/ui-components-web/react/Typography';
import clsx from 'clsx';
import React from 'react';

export const SectionHeader = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => {
  const brand = useBrand();
  const BrandedLogoStickerIcon = {
    curology: CurologyLogoStickerIcon,
    agency: AgencyLogoStickerInverseIcon,
  }[brand];

  return (
    <div className={clsx('cur-flex cur-items-center cur-gap-4', className)}>
      <BrandedLogoStickerIcon size="xl" />
      <Typography className="cur-flex-1" size="body">
        {children}
      </Typography>
    </div>
  );
};
